// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form_Form__DMpDX {
  min-height: 55vh;
  width: 80%;
  padding: 20px;
  background-color: #ffffff;
  margin: 10px;
  border: 1px solid #e3ebf2;
  border-radius: 8px;
  margin-right: 50px;
}
@keyframes Form_rotate-circle__Wa7al {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
.Form_Form__DMpDX .Form_Button__RAR55 {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
@media (max-width: 768px) {
  .Form_Form__DMpDX {
    margin: 0;
    margin-bottom: 15px;
    border-radius: 20px;
  }
  .Form_Form__DMpDX .Form_Button__RAR55 {
    justify-content: center;
  }
}

.Form_ErrorMessage__0zmLg {
  color: #ff0000;
  font-size: 0.8em;
  margin-top: 5px;
}

.Form_SuccessAnimation__CZWwC {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  animation: Form_fadeIn__EANpe 0.5s ease-in;
}
.Form_SuccessAnimation__CZWwC h2 {
  margin-top: 20px;
  color: #4caf50;
}

.Form_CheckmarkCircle__lr0XV {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #4caf50;
  stroke-miterlimit: 10;
  box-shadow: inset 0px 0px 0px #4caf50;
  animation: Form_fill__-E067 0.4s ease-in-out 0.4s forwards, Form_scale__jk-fB 0.3s ease-in-out 0.9s both;
}

.Form_Checkmark__viEIY {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  margin: 10% auto;
  box-shadow: inset 0px 0px 0px #4caf50;
  animation: Form_fill__-E067 0.4s ease-in-out 0.4s forwards, Form_scale__jk-fB 0.3s ease-in-out 0.9s both;
}
.Form_Checkmark__viEIY:after {
  content: "";
  display: block;
  width: 25px;
  height: 50px;
  border: solid #4caf50;
  border-width: 0 8px 8px 0;
  transform: rotate(45deg);
  margin: 25px 0 0 22px;
}

@keyframes Form_fill__-E067 {
  100% {
    box-shadow: inset 0px 0px 0px 30px #4caf50;
  }
}
@keyframes Form_scale__jk-fB {
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
@keyframes Form_fadeIn__EANpe {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Form/Form.module.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBCGc;EDFd,kBAAA;AADF;AAGE;EACE;IACE,yBAAA;EADJ;EAGE;IACE,yBAAA;EADJ;EAGE;IACE,0BAAA;EADJ;EAGE;IACE,0BAAA;EADJ;AACF;AAIE;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAFJ;AAKE;EA/BF;IAgCI,SAAA;IACA,mBAAA;IACA,mBAAA;EAFF;EAIE;IACE,uBAAA;EAFJ;AACF;;AAKA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,0CAAA;AAFF;AAIE;EACE,gBAAA;EACA,cAAA;AAFJ;;AAMA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;EACA,wGAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,qCAAA;EACA,wGAAA;AAHF;AAKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;AAHJ;;AAOA;EACE;IACE,0CAAA;EAJF;AACF;AAOA;EACE;IAEE,eAAA;EANF;EAQA;IACE,+BAAA;EANF;AACF;AASA;EACE;IACE,UAAA;EAPF;EASA;IACE,UAAA;EAPF;AACF","sourcesContent":["@import '../../variables';\n\n.Form {\n  min-height: 55vh;\n  width: 80%;\n  padding: 20px;\n  background-color: $white-color;\n  margin: 10px;\n  border: 1px solid $card-border-color;\n  border-radius: $border-radius;\n  margin-right: 50px;\n\n  @keyframes rotate-circle {\n    0% {\n      transform: rotate(-45deg);\n    }\n    5% {\n      transform: rotate(-45deg);\n    }\n    12% {\n      transform: rotate(-405deg);\n    }\n    100% {\n      transform: rotate(-405deg);\n    }\n  }\n\n  .Button {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 30px;\n  }\n\n  @media (max-width: 768px) {\n    margin: 0;\n    margin-bottom: 15px;\n    border-radius: 20px;\n\n    .Button {\n      justify-content: center;\n    }\n  }\n}\n.ErrorMessage {\n  color: #ff0000;\n  font-size: 0.8em;\n  margin-top: 5px;\n}\n\n.SuccessAnimation {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  animation: fadeIn 0.5s ease-in;\n\n  h2 {\n    margin-top: 20px;\n    color: #4caf50;\n  }\n}\n\n.CheckmarkCircle {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  display: block;\n  stroke-width: 2;\n  stroke: #4caf50;\n  stroke-miterlimit: 10;\n  box-shadow: inset 0px 0px 0px #4caf50;\n  animation: fill 0.4s ease-in-out 0.4s forwards, scale 0.3s ease-in-out 0.9s both;\n}\n\n.Checkmark {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  display: block;\n  stroke-width: 2;\n  stroke: #fff;\n  stroke-miterlimit: 10;\n  margin: 10% auto;\n  box-shadow: inset 0px 0px 0px #4caf50;\n  animation: fill 0.4s ease-in-out 0.4s forwards, scale 0.3s ease-in-out 0.9s both;\n\n  &:after {\n    content: '';\n    display: block;\n    width: 25px;\n    height: 50px;\n    border: solid #4caf50;\n    border-width: 0 8px 8px 0;\n    transform: rotate(45deg);\n    margin: 25px 0 0 22px;\n  }\n}\n\n@keyframes fill {\n  100% {\n    box-shadow: inset 0px 0px 0px 30px #4caf50;\n  }\n}\n\n@keyframes scale {\n  0%,\n  100% {\n    transform: none;\n  }\n  50% {\n    transform: scale3d(1.1, 1.1, 1);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n","// _variables.scss\n\n$primary-color: #ffbc51;\n$primary-dark-color: #d99221;\n$secondary-color: #015d8e;\n$secondary-dark-color: #0b4b6d;\n$white-color: #ffffff;\n$black-color: #212121;\n$black-dark-color: #000000;\n$card-border-color: #e3ebf2;\n$input-background-color: #fafafa;\n\n$border-radius: 8px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Form": `Form_Form__DMpDX`,
	"Button": `Form_Button__RAR55`,
	"ErrorMessage": `Form_ErrorMessage__0zmLg`,
	"SuccessAnimation": `Form_SuccessAnimation__CZWwC`,
	"fadeIn": `Form_fadeIn__EANpe`,
	"CheckmarkCircle": `Form_CheckmarkCircle__lr0XV`,
	"fill": `Form_fill__-E067`,
	"scale": `Form_scale__jk-fB`,
	"Checkmark": `Form_Checkmark__viEIY`,
	"rotate-circle": `Form_rotate-circle__Wa7al`
};
export default ___CSS_LOADER_EXPORT___;
